import { render, staticRenderFns } from "./dados_cadastrais.vue?vue&type=template&id=4b79fe49&scoped=true"
import script from "./dados_cadastrais.vue?vue&type=script&lang=js"
export * from "./dados_cadastrais.vue?vue&type=script&lang=js"
import style0 from "./dados_cadastrais.vue?vue&type=style&index=0&id=4b79fe49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79fe49",
  null
  
)

export default component.exports